import {
  $, $document, ItemView, util
} from '@glu/core';

import template from './rowButtons.hbs';

const $body = $('body');

export default ItemView.extend({
  template,

  events: {
    'click [data-index]': 'onClick',
    'click .dropdown-toggle': 'handleDropdownClick'
  },

  appEvents: {
    'grid:rowButtons:menuOpened': 'destroyPopup'
  },

  initialize() {
    this.prepareButtons();
    this.boundHandleDropdownClose = util.bind(this.handleDropdownClose, this);
    this.destroyOnScrollHandler = util.bind(this.destroyPopup, this);
    this.closeDropdown = util.bind(this.handleDropdownClosing, this);
  },

  attachDropdownEvents() {
    $body.on(`keydown.grid.${this.options.gridCid}`, this.boundHandleDropdownClose);
    $body.on(`click.grid.${this.options.gridCid}`, this.closeDropdown);
    $document.on(`scroll.grid.${this.options.gridCid}`, this.destroyOnScrollHandler);
  },

  detachDropdownEvents() {
    $document.off(`scroll.grid.${this.options.gridCid}`, this.destroyOnScrollHandler);
    $body.off(`keydown.grid.${this.options.gridCid}`, this.boundHandleDropdownClose);
    $body.off(`click.grid.${this.options.gridCid}`, this.closeDropdown);

    if (!this.$dropdownItems) {
      return;
    }

    this.$dropdownItems.off('click');
  },

  onClose() {
    this.destroyPopup();
    this.detachDropdownEvents();
  },

  handleDropdownClose(e) {
    if (!this.secondaryButtons.length || !this.$('.dropdown-menu').data('opened')) {
      return;
    }

    const { keyCode } = $.ui;

    if (e.keyCode === keyCode.ESCAPE) {
      this.destroyPopup();
      this.$('.dropdown-toggle').focus();
    }

    if (e.keyCode === keyCode.TAB) {
      const $el = $document.find(e.target);
      const $parent = $el.closest('.dropdown-menu');
      const $items = $parent.find('a');
      const linkIndex = $items.index($el);
      const $firstLink = $items.first();
      const $lastLink = $items.last();

      if (e.shiftKey) {
        if (linkIndex === $items.index($firstLink)) {
          $lastLink.focus();
          e.preventDefault();
        }
      } else if (linkIndex === $items.index($lastLink)) {
        $firstLink.focus();
        e.preventDefault();
      }
    }
  },

  handleDropdownClosing(e) {
    const $el = this.$(e.currentTarget);

    if ($el.is(this.$('.dropdown-toggle')) && $el.closest('.btn-group').length) {
      return;
    }

    this.destroyPopup();
  },

  prepareButtons() {
    const actions = this.options.column.get('rowButtons');
    if (actions && util.isFunction(actions.on)) {
      this.listenTo(actions, 'change', () => {
        this.doPrepareButtons();
        this.render();
      });
    }
    this.doPrepareButtons();
  },

  doPrepareButtons() {
    const { theme } = this.options;
    const actions = this.options.column.get('rowButtons');

    let finalActions = null;
    if (util.isArray(actions)) {
      finalActions = actions;
    } else if (util.isFunction(actions)) {
      finalActions = actions(this.model);
    }

    this.rowButtons = util.filter(finalActions, (btn) => !btn.bulkActionOnly &&
      !(util.isFunction(btn.condition) && !btn.condition(this.model)));

    if (theme && theme.name === 'ash') {
      if (this.rowButtons.length === 1) {
        [this.primaryButton] = this.rowButtons;
      } else {
        this.primaryButton = false;
        this.secondaryButtons = this.rowButtons;
      }
    } else {
      [this.primaryButton] = this.rowButtons;
      this.secondaryButtons = util.rest(this.rowButtons);
    }
  },

  templateHelpers() {
    return {
      primaryButton: this.primaryButton,
      secondaryButtons: this.secondaryButtons,
      cid: this.model.cid,
      noPrimaryButton: this.noPrimaryButton,
      addTitleToPrimaryButton: !this.secondaryButtons && this.options.theme && this.options.theme.name === 'ash'
    };
  },

  destroyPopup() {
    const $openedMenu = $body.find('> ul[id^="grid-dropdown"]');
    let $initialMenu;

    if ($openedMenu.length) {
      $initialMenu = $document.find(`[data-id="${$openedMenu.attr('id')}"]`);
    } else {
      return;
    }

    this.detachDropdownEvents();

    $initialMenu
      .attr('aria-expanded', false)
      .attr('id', $initialMenu.attr('data-id'))
      .data('opened', false);

    this.$('.btn-group').removeClass('dropup');
    $openedMenu.remove();
  },

  onClick(e) {
    e.preventDefault();

    const shift = this.primaryButton === false ? 0 : 1;
    // Use $document because the dropdown is positioned on the body.
    const buttonIndex = $document.find(e.currentTarget).data('index') + shift;
    const { handler } = this.rowButtons[buttonIndex];

    handler.apply(this, [e, this.model]);
  },

  handleDropdownClick(e) {
    e.stopPropagation();
    e.preventDefault();

    const $menu = this.$('.dropdown-menu');

    if ($menu.data('opened')) {
      // user clicks dropdown button twice
      this.destroyPopup();
      return;
    }

    this.appBus.trigger('grid:rowButtons:menuOpened');

    this.attachDropdownEvents();

    const $el = this.$(e.currentTarget);
    const $menuClone = $menu.clone(false);
    const id = $menu.attr('id');

    this.$dropdownItems = $menuClone.find('[data-index]');

    this.$dropdownItems.on('click', (...args) => {
      this.onClick(...args);

      this.destroyPopup();
    });

    this.$('.dropdown-toggle').attr('aria-expanded', true);
    $menu.data('opened', true);
    $menu.removeAttr('id').attr('data-id', id);

    // If another another .dropdown-menu exists, then here is the point of GLU-1301
    $menuClone.attr('id', id).appendTo($body);

    if (this.secondaryButtons) {
      this.setPopupPosition($el, $menuClone);
    }

    this.$dropdownItems.first().focus();
  },

  setPopupPosition($el, $menuClone) {
    const { theme } = this.options;
    const horizontalOffset = theme && !theme.legacy ? 20 : 0;
    const $firstButton = this.$('.btn-group > button:first-child');
    const offset = $el.offset();
    const horizontalPosition = offset.left - $firstButton.outerWidth() + horizontalOffset;
    let verticalPosition = offset.top + $el.height();
    const documentHeight = $body.outerHeight();
    const popupHeight = $menuClone.outerHeight();

    if (documentHeight < (verticalPosition + popupHeight - window.pageYOffset)) {
      verticalPosition -= (popupHeight + $firstButton.outerHeight());
      this.$('.btn-group').addClass('dropup');
    }

    $menuClone.css({
      left: horizontalPosition,
      top: verticalPosition,
      display: 'block'
    });
  }
});
